document.addEventListener('DOMContentLoaded', init);

function init() {
  if ( window.innerWidth < 769 ) {
    toggle_menu_archive_mobile()
    footer_grid_tiendas()
  }
}

function toggle_menu_archive_mobile() {
	const togglesCont = document.querySelector('.copilot__menu-items');
	if (togglesCont) {
        const toggles = document.querySelectorAll('.copilot__menu-items h3');
        toggles.forEach(function(toggle) {
            toggle.addEventListener('click', function() {
              jQuery(toggle).toggleClass('collapsed');
              jQuery(toggle).next().toggle();
            });
        })
	}
}

function footer_grid_tiendas() {
  const allPs = Array.from(document.querySelectorAll('.footer__block--text .prose p'));
  const container = document.querySelector('.footer__block--text .prose');

  const col1 = document.createElement('div');
  col1.classList.add('col');

  const col2 = document.createElement('div');
  col2.classList.add('col');

  allPs.forEach((p, index) => {
    if (p.textContent == "&nbsp;" || p.textContent == ' ' || p.textContent == '' || index == 4) {
      p.remove();
    } else {
      if (index < 4) {
        col1.appendChild(p);
      } else {
        col2.appendChild(p);
      }
    }
  });

  container.appendChild(col1);
  container.appendChild(col2);
}